import { Injectable } from '@angular/core';
import {RequestProvider} from "../request/request";

/*
  Generated class for the ErrorListProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ErrorListProvider {

  public selectedErrorList: any;
  public insertErrorListIndex: any;
  public insertErrorListMode: any;

  constructor(
    public request: RequestProvider
  ) {
  }

  searchMostlyOkLists(term: string) {
    return new Promise((resolve, reject) => {
      this.request.get(`mostly.ok.list/search/${term}`, true).subscribe(data => {
        if (data.count == 0) resolve([]);
        else resolve(data.results);
      }, err => {
        resolve([]);
      });
    });
  }

  searchErrorLists(term: string) {
    return new Promise((resolve, reject) => {
      this.request.get(`error.list/search/${term}`, true).subscribe(data => {
        if (data.count == 0) resolve([]);
        else resolve(data.results);
      }, err => {
        resolve([]);
      });
    });
  }


}



// WEBPACK FOOTER //
// ./src/providers/error-list/error-list.ts